// src/components/OddsTable.jsx
import React, { useState } from "react";
import styles from "../styles/FixturePage.module.css";

// ✅ NEW: decimal + fractional formatter
import { formatOddsBoth } from "../utils/oddsFormat";
import { formatMarketName } from "../utils/formatMarketName";

const LIVE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes

const isLive = (lastSeen) => {
  if (!lastSeen) return false;
  const ts = lastSeen.endsWith("Z") ? lastSeen : lastSeen + "Z";
  return Date.now() - new Date(ts).getTime() < LIVE_THRESHOLD_MS;
};

const OddsTable = ({ grouped }) => {
  const [expandedMarkets, setExpandedMarkets] = useState({});

  const toggleMarket = (market) => {
    setExpandedMarkets((p) => ({ ...p, [market]: !p[market] }));
  };

  // check if any odds in a market are live, so we can badge the header too
  const marketHasLive = (market) =>
    (grouped[market] || []).some((o) => isLive(o.last_seen));

  return (
    <div className={styles.oddsSection}>
      <h3>All Odds</h3>
      {Object.keys(grouped).map((market) => (
        <div key={market} className={styles.oddsMarket}>
          <h4 onClick={() => toggleMarket(market)}>
            {formatMarketName(market)}{" "}
            {marketHasLive(market) && (
              <span style={{
                display: "inline-block",
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.5,
                color: "#fff",
                background: "#16a34a",
                borderRadius: 999,
                padding: "1px 6px",
                marginRight: 4,
                verticalAlign: "middle",
              }}>
                LIVE
              </span>
            )}
            {expandedMarkets[market] ? "▲" : "▼"}
          </h4>

          {expandedMarkets[market] && (
            <table className={styles.oddsTable}>
              <thead>
                <tr>
                  <th>Bookmaker</th>
                  <th>Price</th>
                  <th>Last Seen</th>
                </tr>
              </thead>

              <tbody>
                {grouped[market].map((o, i) => {
                  const ts = (o.last_seen || "").endsWith("Z")
                    ? o.last_seen
                    : (o.last_seen || "") + "Z";
                  const live = isLive(o.last_seen);

                  return (
                    <tr key={i}>
                      <td>{o.bookmaker}</td>
                      <td>
                        <b>{formatOddsBoth(o.price)}</b>
                        {live && (
                          <span style={{
                            display: "inline-block",
                            fontSize: 9,
                            fontWeight: 700,
                            color: "#fff",
                            background: "#16a34a",
                            borderRadius: 999,
                            padding: "1px 5px",
                            marginLeft: 6,
                            verticalAlign: "middle",
                          }}>
                            LIVE
                          </span>
                        )}
                      </td>
                      <td>
                        {o.last_seen
                          ? new Date(ts).toLocaleString(navigator.language, {
                              hour: "2-digit",
                              minute: "2-digit",
                              day: "numeric",
                              month: "short",
                              timeZone:
                                Intl.DateTimeFormat().resolvedOptions().timeZone,
                            })
                          : "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
};

export default OddsTable;
